module.exports = __webpack_public_path__ + "static/media/CARD_DIAMOND@3x.c055c89d.png";